<script>
/* Waveform generation process can be found here: https://css-tricks.com/making-an-audio-waveform-visualizer-with-vanilla-javascript/ */
import {
    projectState
} from '@app/store/projectStore.js'
import {
    playerState
} from '@app/store/playerStore.js';
import {
    audioWaveformState
} from '@app/store/audioWaveformStore.js';
import { onDestroy, createEventDispatcher } from 'svelte';
import * as Comlink from "comlink";
import debounce from "just-debounce-it";

export let scrollPosition = 0;
export let scaleMultiplier = 64;
export let width = 1920;
export let height = 40;

const dispatch = createEventDispatcher();

let mediaFilePath,
    start = 0,
    end = 0,
    waveformSvgPaths = [],
    pixelsPerSample = 1,
    rawData;

const audioContext = new AudioContext();
const waveformWorker = new Worker("./build/workers/waveform.js");
const WaveformGenerator = Comlink.wrap(waveformWorker);


let nextUpdatePos = scrollPosition + (width/2);
let prevUpdatePos = scrollPosition - (width/2);

onDestroy(async () => {
    waveformWorker.terminate();
});

async function getWaveformData(){
    try {
        mediaFilePath = $projectState.media.path;
        waveformSvgPaths = [];
        let rawBuffer = await WaveformGenerator.getRawBuffer($projectState.media.audioPath);
        let audioBuffer = await audioContext.decodeAudioData(rawBuffer);
        // console.log(audioBuffer);
        rawData = audioBuffer.getChannelData(0);
        getSvgData();
    } catch(err){
        rawData = undefined;
        console.warn("Failed to retrieve Waveform Data.", err.message, err);
    }
}

const getSvgData = debounce(async () => {
    console.log("Redrawing waveform after throttle...")
    if (rawData){
        waveformSvgPaths = await WaveformGenerator.getSvgData(rawData, $playerState.duration, scaleMultiplier, pixelsPerSample, $audioWaveformState.zoom, height, $audioWaveformState.multiplier);    
        updateVisibleWaveform();
        dispatch('svgDataUpdate');
    }    
}, 500);

async function  updateVisibleWaveform(){
    start = parseInt(Math.max(0,(scrollPosition-width)/pixelsPerSample));
    end = parseInt((scrollPosition+(width*1.5))/pixelsPerSample);
    nextUpdatePos = scrollPosition + (width/2);
    prevUpdatePos = scrollPosition - (width/2);
}

$: if ($projectState.media.path !== mediaFilePath){
    console.log($projectState.media.path, mediaFilePath);
    console.log("Media File Path has changed. Getting waveform data");
    getWaveformData();
}

$: if (scaleMultiplier){
    console.log("Scale multiplier change... getting svg data");
    getSvgData(scaleMultiplier);
}

$: if ($audioWaveformState){
    console.log("Amplification change. Redrawing waveform");
    getSvgData();
}

$: if (height){
    console.log("Height change. Redrawing waveform");
    getSvgData();
}

$: if (scrollPosition >= nextUpdatePos || scrollPosition <= prevUpdatePos) {
    console.log("Updating Visible Waveform");
    updateVisibleWaveform();
}

</script>
<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="border-bottom border-secondary m-0 p-0 TimelineTrack col-12" style="min-width: {$playerState.duration*scaleMultiplier}px; height: {height}px" on:click="{(e) => {window.player.currentTime = e.offsetX/scaleMultiplier; playerState.updateTime(e.offsetX/scaleMultiplier)}}">
    <svg style="user-select:none;" height="{height}" width="{waveformSvgPaths.length*pixelsPerSample}px" stroke="#00bc8c" fill="#00bc8c" stroke-width="{pixelsPerSample}">
        <path d="{waveformSvgPaths.slice(start, end).join(" ")}" />
    </svg>
</div>